<div style="width: 292px; border: #d7d7d7 solid 1px; border-radius: 5px; height: 102px;">
  <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>
  <label class="f-12 clear-style"> Draw Your Signature Here. <a class="text-underline f-11 pointer" (click)="clearPad()">Clear Signature</a></label><br/>
</div>
